
<script>
export default {
  name: 'RexDistance',
  props: {
    name: {
      type: String,
      default: () => null,
      required: true
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    maxValue: {
      type: Number,
      default: () => null,
      required: true
    },
    getter: {
      type: String,
      default: () => 'getField'
    },
    setter: {
      type: String,
      default: () => 'setField'
    },
    label: {
      type: String,
      default: () => null
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    renderValue: 0,
  }),
  computed: {
    position: {
      get() {
        const distance = this.$store.getters[`${this.storeModule}/${this.getter}`](this.target)

        this.setRenderValue(distance)

        let position

        if (this.maxValue > 10 && distance <= 5) {
          position = distance * 10
        } else {
          position = distance / (this.maxValue / 100)
        }

        return Math.round(position)
      },
      set(position) {
        let distance

        if (this.maxValue > 10 && position <= 50) {
          distance = position / 10
        } else {
          distance = (position / 100) * this.maxValue
        }

        this.$store.commit(`${this.storeModule}/${this.setter}`, {
          target: this.target,
          value: Math.round(distance * 10) / 10
        })
      }
    }
  },
  methods: {
    setRenderValue(value) {
      this.renderValue = value
    },
    updateRenderValue(position) {
      let distance

      if (this.maxValue > 10 && position <= 50) {
        distance = position / 10
      } else {
        distance = (position / 100) * this.maxValue
      }

      this.renderValue = Math.round(distance * 10) / 10
    },
    change() {
      this.$emit('change', {
        event: this.position,
        element: this.$vnode.elm
      })
    }
  }
}
</script>

<template>
  <b-field
    custom-class="rex-label"
    :label="label"
  >
    <div class="rex-distance">
      <b-slider
        v-model="position"
        :min="0"
        :max="100"
        :step="1"
        :tooltip="false"
        :disabled="isDisabled"
        lazy
        @dragging="updateRenderValue"
        @dragend="change"
      />
      <div
        class="rex-distance__value"
        :class="{
          'rex-distance__value--disabled': isDisabled
        }"
      >
        <span>{{ `${renderValue} км.` }}</span>
      </div>
    </div>
  </b-field>
</template>